import React, { memo, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '../Button';
import { ThemeProvider } from "@material-ui/styles";
import { MenuTheme } from '../../../shared/themes/menuTheme';
import SVG from 'react-inlinesvg';

const ButtonMenu = ({ className, buttonClassName, titleButton, options = [], onDirectClick }) => {

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        if (onDirectClick) {
            onDirectClick();
            return;
        }
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const handleClickItem = (action) => {
        if (action) {
            action();
        }
        handleClose();
    }

    return (
        <>
            <Button className={buttonClassName} onClick={handleClick}>{titleButton}</Button>
            <ThemeProvider theme={MenuTheme}>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    {
                        options.map((option, i) => (
                            <MenuItem key={i} onClick={handleClickItem.bind(this, option.action)}>
                                {
                                    typeof option.icon !== "undefined" &&
                                    <SVG src={option.icon} />
                                }
                                <span> {option.label} </span>
                            </MenuItem>
                        ))
                    }
                </Menu>
            </ThemeProvider>
        </>
    );


}

export default memo(ButtonMenu);